import { render, staticRenderFns } from "./BookAppealDateRspToAppealPg.vue?vue&type=template&id=0fbe73fe&scoped=true"
import script from "./BookAppealDateRspToAppealPg.vue?vue&type=script&lang=ts"
export * from "./BookAppealDateRspToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbe73fe",
  null
  
)

export default component.exports